import { useMemo } from "react";
import { getAllEncriptionNames } from "../../../../../CommonComponents/security-configuration/helperFunctions";
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import useSecurityConfig from "../../../../hooks/useSecurityConfig";
import { EncripTionOptionType } from "../../../../../CommonComponents/security-configuration/types";

const EncriptionSelectionSection = () => {
    const { securityConfig, securityConfigFormData, setSecurityConfigFormData, EncripTionOptions, getRelatedSecurityIndex } = useSecurityConfig()

    const selectedKeyType = useMemo(() => securityConfigFormData?.keyType, [securityConfigFormData?.keyType]);
    const options = useMemo(() => securityConfig ? getAllEncriptionNames(securityConfig) : EncripTionOptions, [securityConfig, EncripTionOptions]);
    const filterdOptions = useMemo(() => getRelatedSecurityIndex(options, selectedKeyType), [options, selectedKeyType]);
    const toggle = useMemo(() => securityConfigFormData?.encriptionEnabled, [securityConfigFormData]);
    const selected = useMemo(() => securityConfigFormData?.encriptionKey, [securityConfigFormData]);

    const setToggle = (value: boolean) => {
        setSecurityConfigFormData({
            ...securityConfigFormData,
            encriptionEnabled: value
        })
    }

    const setSelected = (value: EncripTionOptionType) => {
        setSecurityConfigFormData({
            ...securityConfigFormData,
            encriptionKey: value
        })
    }

    return (
        <div className='encription__selection__section'>
            <div className='__checkbox__container'>
                {/* <input className="__checkbox"
                    type="checkbox"
                    id="encription"
                    checked={toggle}
                    onChange={() => setToggle(!toggle)}
                /> */}
                <span className="__checkbox__label">Encryption</span>
            </div>
            {filterdOptions.map((item) => {
                const showButton = filterdOptions?.length > 1
                const isSelected = item.value === selected.value;
                if (!isSelected) return null;
                return (
                    <div className='__encription__selection__container'>
                        {showButton &&
                            <button className='__selection__button'
                                onClick={() => setSelected(filterdOptions[selected.prevIndex])}
                            >
                                <ArrowLeftIcon />
                            </button>
                        }
                        <div className='__selected__content__container'>
                            <span className='__selected__content'>{selected.label}</span>
                        </div>
                        {showButton &&
                            <button className='__selection__button'
                                onClick={() => setSelected(filterdOptions[selected.nextIndex])}
                            >
                                <ArrowRightIcon />
                            </button>
                        }
                    </div>
                )
            })}
        </div>
    )
}

export default EncriptionSelectionSection